import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { AutoComplete, Icon, Input } from 'antd';
import s from './style.css';

const { Option } = AutoComplete;

class AddToRelatedQuestion extends Component {
  onChange = v => this.props.setACValue(v);
  handleQuestionSelect = (value, option) => {
    if (!value) {
      return;
    }
    this.props.setMatchAnswer({
      id: value,
      answer: option.props.answer,
      title: option.props.title,
    });
  };
  render() {
    const { setModals, item } = this.props;
    const {
      acValue,
      autoCompleteQuestions,
      autoCompleteLoading,
      handleQuestionACSearch,
    } = this.props;
    const options = autoCompleteLoading
      ? [
          <Option key="" value="" title="">
            <Icon type="loading" />
          </Option>,
        ]
      : autoCompleteQuestions.map(x => (
          <Option
            key={x.id}
            value={String(x.id)}
            title={x.title}
            answer={x.answer}
          >
            {x.title}
          </Option>
        ));
    return (
      <div>
        <AutoComplete
          autoFocus={!!1}
          value={acValue || ''}
          size="large"
          style={{ width: '100%' }}
          onSearch={handleQuestionACSearch}
          onChange={this.onChange}
          optionLabelProp="title"
          onSelect={this.handleQuestionSelect}
          on
          dataSource={options}
          placeholder="请输入问题关键字查询"
        >
          <Input
            suffix={<Icon type="search" className="certain-category-icon" />}
          />
        </AutoComplete>
        <div className={s.newQS}>
          <a
            onClick={async () => {
              await setModals({
                key: 'relatedQS',
                title: '',
                visible: false,
              });
              await setModals({
                key: 'addQuestionModal',
                title: '添加问题',
                visible: true,
                item: {
                  ...item,
                  addRelated: true,
                },
              });
            }}
          >
            <Icon type="plus" />
            没有找到类似的问题？新建一个（自动关联）
          </a>
        </div>
      </div>
    );
  }
}

AddToRelatedQuestion.propTypes = {
  setModals: PropTypes.func.isRequired,
  acValue: PropTypes.string.isRequired,
  setMatchAnswer: PropTypes.func.isRequired,
  setACValue: PropTypes.func.isRequired,
  handleQuestionACSearch: PropTypes.func.isRequired,
  item: PropTypes.shape().isRequired,
  autoCompleteLoading: PropTypes.bool.isRequired,
  autoCompleteQuestions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default AddToRelatedQuestion;
